module.exports = __webpack_public_path__ + "static/media/loading.195d8f38.gif";